<template>
    <!-- Bloque de una sección: título + qué completar + campos -->
    <component :is="tag" :class="['ee-pb', clase]">
        <div class="ee-pb-h"><p class="ee-pb-t">{{ titulo }}</p><slot name="extra" /></div>
        <p v-if="ayuda" class="ee-pb-c">{{ ayuda }}</p>
        <slot />
    </component>
</template>

<script>
export default {
    name: 'EeBloque',
    props: {
        titulo: { type: String, required: true },
        ayuda: { type: String, default: '' },
        clase: { type: [String, Array, Object], default: '' },
        tag: { type: String, default: 'div' },
    },
};
</script>
